import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  accordion: {
    '&.MuiAccordion-root': {
      borderRadius: theme.shape.borderRadius,
      boxShadow: 'none',
      border: 'none',
      '&:before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 0,
      },
    },
  },
  summary: {
    backgroundColor: 'rgba(245, 245, 245, 1)',
    borderBottom: 'none',
    minHeight: '38px',

    '&.MuiAccordionSummary-root': {
      minHeight: '38px',
    },
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(1, 2, 1, 0),
      overflow: 'hidden',
      marginRight: theme.spacing(2),

      '&.Mui-expanded': {},
    },
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: 'grey',
    flexGrow: 1,
    position: 'relative',

    '& span': {
      position: 'relative',
      paddingRight: theme.spacing(2),
      zIndex: 1,
      backgroundColor: 'rgba(245, 245, 245, 1)',
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 12,
      right: 0,
      height: '1px',
      width: '100%',
      backgroundColor: '#e0e0e0',
      zIndex: 0,
    },
  },
  details: {
    padding: theme.spacing(3),
    backgroundColor: '#fff',
  },
  expandIcon: {
    fontSize: '1.2rem',
    color: 'grey',
  },
}));

interface JobAccordionProps {
  title: string;
  defaultExpanded?: boolean;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
  children: React.ReactNode;
}

export const JobAccordion: React.FC<JobAccordionProps> = ({
  title,
  defaultExpanded = false,
  expanded,
  onChange,
  children,
}) => {
  const classes = useStyles();

  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (onChange) {
      onChange(isExpanded);
    }
  };

  // If expanded prop is provided, the component is controlled
  const isControlled = expanded !== undefined;

  return (
    <Accordion
      className={classes.accordion}
      defaultExpanded={!isControlled && defaultExpanded}
      expanded={isControlled ? expanded : undefined}
      onChange={handleChange}
    >
      <AccordionSummary
        expandIcon={<KeyboardArrowDownIcon className={classes.expandIcon} />}
        className={classes.summary}
      >
        <Typography className={classes.title}>
          <span>{title}</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Box>{children}</Box>
      </AccordionDetails>
    </Accordion>
  );
};
